import React, { Component } from 'react';
import { Divider } from './common/atoms';
import CustomDrawer from './common/organisms/Drawer';
import HelpDrawerBody from './Others/HelpDrawerBody';
import HelpApi from '../services/help.api';
import handleAppError from './handlers/handleAppError';
import { Redirect } from 'react-router-dom';
import { Help } from '../assets/images';
import appApi from '../services/app.api';
import { Select, Tooltip } from 'antd';
import { DSIcon } from './common/atoms';
import { AppDispatchContext } from '../utils/contexts';

const Option = Select.Option;

class NavBar extends Component {
  constructor(props) {

    super(props);
  }
  static contextType = AppDispatchContext

  state = {
    help_data: null,
    redirect: false,
    showUserProfile: false
  };

  logout = () => {
    appApi.logout({}, this.onSuccess, this.onError);
  };

  onSuccess = (res) => {
    sessionStorage.removeItem('company_id');
    sessionStorage.clear();
    this.setState({ redirect: true });
  };

  onError = (err) => {
    handleAppError(err);
  };

  getHelpData = async () => {
    await HelpApi.help_request(
      {},
      (res) => this.setState({ help_data: res.data }),
      (err) => handleAppError(err)
    );
  };

  toggleUserProfile = () => {
    this.setState({ showUserProfile: !this.state.showUserProfile });
  };

  makeShowProfileFalse = (e) => {
    if (e.target.parentNode?.id !== 'profile')
      this.setState({ showUserProfile: this.state.showUserProfile ? !this.state.showUserProfile : false });
  };

  componentDidMount() {
    this.getHelpData();
    window.addEventListener('click', this.makeShowProfileFalse);
    window.addEventListener("overviewCompaniesChanged", this.handleOverviewCompaniesChange);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.makeShowProfileFalse);
    window.removeEventListener("overviewCompaniesChanged", this.handleOverviewCompaniesChange);
  }

  handleOverviewCompaniesChange = () => {
    const overviewSelectedCompanies = JSON.parse(sessionStorage.getItem("overviewSelectedCompanies") || "[]");
    const companies = JSON.parse(sessionStorage.getItem("companies") || "[]");

    if (overviewSelectedCompanies.length === 1) {
      const selectedCompanyId = overviewSelectedCompanies[0];
      const selectedCompany = companies.find(c => c.id === selectedCompanyId);

      if (selectedCompany) {
        const key = {
          props: {
            companyName: selectedCompany.name,
            isChildCompany: selectedCompany.parent_company_id,
            calendarToken: selectedCompany.calendar_token,
            launchDate: selectedCompany.launch_date
          }
        };

        this.handleChange(selectedCompanyId, key);
      }
    }
  };

  handleChange = (value, key) => {
    let cal_http_https = window.API_URL.search('https') === -1 ? 'http' : 'https';
    let api_url = window.API_URL;
    let cal_url = api_url.replace('/v1/', '');
    window.axios.defaults.headers.common['X-COMPANY-ID'] = value;
    sessionStorage.setItem('company_id', value);
    sessionStorage.setItem('company_name', key.props.companyName);
    sessionStorage.setItem('is_child_company', JSON.stringify(key.props.isChildCompany ?? false));
    sessionStorage.setItem('launch_date', key.props.launchDate);
    this.context({ companyId: parseInt(value, 10) })

    // window.location.pathname = window.location.pathname;
    this.props.getDigitizationFlag();
    this.props.fetchBenefitList();

    const { that } = this.props;
    that.setState({ dummyChild: 'unmount' });

    setTimeout(() => {
      that.setState({ dummyChild: '' });
    });



    sessionStorage.setItem(
      'calendar_url',
      cal_url.replace(cal_http_https, 'webcal') + '/calendar/' + key.props.calendarToken + '/calendar.ics'
    );

  };

  handleBlur() {
    // console.log('blur');
  }

  handleFocus() {
    // console.log('focus');
  }

  showCompany() {
    let companies = JSON.parse(sessionStorage.getItem("companies") || "[]");
    let overviewSelectedCompanies = JSON.parse(sessionStorage.getItem("overviewSelectedCompanies") || "[]");
    let selectedCompany =
      overviewSelectedCompanies.length === 0
        ? parseInt(sessionStorage.getItem("company_id"), 10)
        : overviewSelectedCompanies.length === 1
          ? overviewSelectedCompanies[0]
          : `${overviewSelectedCompanies.length} Companies Selected`;

    if (
      ((this.props.previousState.role === null || this.props.previousState.role === undefined) ? " " : this.props.previousState.role.toLowerCase()) === 'broker' ||
      ((this.props.previousState.role === null || this.props.previousState.role === undefined) ? " " : this.props.previousState.role.toLowerCase()) === 'csm' ||
      ((this.props.previousState.role === null || this.props.previousState.role === undefined) ? " " : this.props.previousState.role.toLowerCase()) === 'csmmaster' ||
      ((this.props.previousState.role === null || this.props.previousState.role === undefined) ? " " : this.props.previousState.role.toLowerCase()) === 'staff' && companies.length > 1
    ) {
      return (
        <span style={{ paddingLeft: 12 }}>
          <Select
            showSearch
            style={{ width: 250, backgroundColor: '#fff' }}
            value={selectedCompany || undefined}
            placeholder='Select a company'
            optionFilterProp='children'
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            filterOption={(input, option) => {
              const labelText = React.Children.toArray(option.props.children)
                .filter((child) => typeof child === "string")
                .join("")
                .toLowerCase();
              return labelText.includes(input.toLowerCase());
            }}
          >
            {companies.map((key) => {
              return (
                <Option key={key.name} value={key.id} companyName={key.name} isChildCompany={key.parent_company_id} calendarToken={key.calendar_token} launchDate={key.launch_date} >
                  {key.name} <span className='text-xs font-fig-normal'>{(key.enable_spending_account || key.remote_wallet_enabled) ? '(OPD)' : ''}</span>
                </Option>
              );
            })}
          </Select>
        </span>
      );
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to='/login' />;
    }

    const { showUserProfile } = this.state;
    const hrName = sessionStorage.getItem('hr_name') || 'User';
    const avatarText = hrName
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase() || '')
      .join('') || 'U';

    return (
      <nav className='fixed right-0 z-10 w-full border-b border-gray-300 bg-gray-50'>
        <div className='ml-60 px-4 sm:px-6 lg:px-8 lg:pl-1'>
          <div className='flex h-16 justify-between'>
            <div className='flex justify-start'>
              <div className='flex items-center'>{this.showCompany()}</div>
            </div>
            <div className='hidden sm:ml-6 sm:flex sm:items-center'>
              <div className='flex'>

                {!['CSM', 'CSMMaster'].includes(sessionStorage.getItem('role')) && (
                  <Tooltip placement='bottom' title='Help'>
                    <button
                      type='button'
                      onClick={() => this.props.toggleHelp()}
                      className='ml-12 inline-flex h-10 w-10 items-center justify-center rounded-full border border-transparent bg-white text-gray-500 transition-colors hover:border-gray-200 hover:bg-gray-50 hover:text-gray-800 focus:outline-none focus:ring-2 focus:ring-ds-brand focus:ring-offset-2'
                    >
                      <img className='h-7 w-7' src={Help} alt='' />
                    </button>
                  </Tooltip>
                )}
              </div>

              <Divider type='vertical' classes='h-7 mr-4 ml-4' />

              <div className='relative'>
                <div
                  id='profile'
                  className='flex cursor-pointer items-center rounded-[10px] px-2 py-1.5 transition-colors duration-150 hover:bg-gray-50 focus:outline-none'
                  onClick={this.toggleUserProfile}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      this.toggleUserProfile();
                    }
                  }}
                  role='button'
                  tabIndex={0}
                >
                  <div className='relative mr-3'>
                    <div className='flex h-10 w-10 items-center justify-center rounded-full border border-gray-300 bg-gray-100 text-[12px] font-semibold text-gray-700'>
                      {avatarText}
                    </div>
                    <span className='absolute bottom-0 right-0 h-2.5 w-2.5 rounded-full bg-green-700 ring-2 ring-white' aria-hidden />
                  </div>
                  <div className='mr-2 text-[13px] font-medium text-gray-800'>{hrName}</div>
                  <DSIcon name={showUserProfile ? 'chevron-up' : 'chevron-down'} size={16} className='shrink-0 text-gray-500' title={showUserProfile ? 'Collapse menu' : 'Expand menu'} />
                </div>
                {showUserProfile && (
                  <div
                    className='absolute -right-4 z-10 mt-2 origin-top-right overflow-hidden rounded-xl border border-gray-300 bg-white py-1 shadow-lg focus:outline-none'
                    role='menu'
                    aria-orientation='vertical'
                    aria-labelledby='user-menu'
                  >
                    <span className='block px-4 py-2.5 text-[13px] text-gray-600' role='presentation'>
                      {sessionStorage.getItem('hr_email')}
                    </span>
                    <a
                      className='block px-4 py-2.5 text-[13px] text-gray-800 transition-colors hover:bg-gray-50 focus:bg-gray-50 focus:outline-none'
                      href='/account-settings'
                      role='menuitem'
                    >
                      Account Settings
                    </a>
                    <button
                      type='button'
                      className='block w-full px-4 py-2.5 text-left text-[13px] text-gray-800 transition-colors hover:bg-gray-50 focus:bg-gray-50 focus:outline-none'
                      onClick={this.logout}
                      role='menuitem'
                    >
                      Sign out
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <CustomDrawer
          title='Help'
          body={
            <HelpDrawerBody
              initialKey={this.props.initialKey}
              data={this.state.help_data}
              reset={!this.props.showhelp}
            />
          }
          subHeaderStyle={{
            fontSize: '18px',
            fontWeight: '600',
            color: '#4B5563',
            display: 'flex',
            justifyContent: 'space-between',
          }}
          visible={this.props.showhelp}
          width='37%'
          headerStyle={{
            backgroundColor: '#F9FAFB',
            height: '61px',
            padding: '19px 24px',
          }}
          close={this.props.toggleHelp}
          className='help-drawer-xs'
        ></CustomDrawer>
      </nav>
    );
  }
}

export default NavBar;
